import axios from 'axios';
import { ethers } from 'ethers';
import { gapi } from 'gapi-script';
import { forwardRef, useEffect, useState } from "react";
import styled from 'styled-components';
import ERC20Artifact from "../artifacts/@openzeppelin/contracts/token/ERC20/IERC20.sol/IERC20.json";
import LicenseSoulboundNFTArtifact from "../artifacts/contracts/LicenseSoulboundNFT.sol/LicenseSoulboundNFT.json";
import MasterCopy from "../common/models/MasterCopy";
import { User } from "../common/models/User";
import CloseCircle from '../components/Buttons/CloseCircle';
import SimpleButton from "../components/Buttons/SimpleButton";
import Column from "../components/Column/Column";
import { Modal } from "../components/Modal/Modal";
import { CircularSVG, CustomCircle } from '../components/ProgressBar/CircluarSVG';
import Row from '../components/Row/Row';
import { BlockChainErrorText } from '../components/Text/BlockchainErrorText';
import { ProgressText } from '../components/Text/ProgressText';
import Text from '../components/Text/Text';
import { useAuth } from "../hooks/useAuth";
import close_circle from '../imgs/close-circle.svg';
import eth_icon from '../imgs/eth_icon_blue.svg';
import { getSelectedProvider, sleep } from '../utils';

interface SongLicenseModalProps {
  theme: string;
  artist: User;
  song: MasterCopy;
  showSongLicenseModal: boolean;
  onLicenseCloseClick: any;
  onLicenseSuccess: any;
  showResult: boolean;
}

const CheckoutPriceContainer = styled("div")`
  color: #03bbf5;
  border: 1px solid #03bbf5;
  border-radius: 8px;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: auto;
`;

const SongLicenseContainer = styled("div")`
  display: flex;
  border: 1px solid #ffffff90;
  border-radius: 12px;
  width: 100%;
`;

const SongLicenseImg = styled("img")`
  width: 200px;
  height: 150px;
  position: relative;
  display: inline-block;
  overflow: hidden;
  margin: 0;
  border-radius: 12px;
`;
const SubscriberCountBar = styled("div")`
  align-items: center;
  text-align: center;
  margin-top: 2%;
  width: 95%;
  height: 1vh;
  background-color: #616387;
`;
const SubscriberCategoryColumn = styled(Column)`
  align-items: center;
  text-align: center;
  margin-right: 2%;
  height: 100%;
  width: 33%;
`;
const SubsriberCountColumn = styled(Column)`
  width: 33%;
  height: 25%;
`;

const StandardLicenseColumn = styled(Column)`
  justify-content: start;
  padding-left: 0%;
  height: 100%;
  width: 100%;
`;

const YoutubeButton = styled(SimpleButton)`
  align-self: start;
`;

const SongLicenseModalContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000d30;
  z-index: 3;
  border-radius: 20px;
  padding-block: 3%;
  padding-inline: 5%;
  border: 1px solid #ffffff90;
`;

const SongLicenseModal = forwardRef<HTMLDivElement, SongLicenseModalProps>(
  (
    {
      theme,
      artist,
      song,
      showSongLicenseModal,
      onLicenseCloseClick,
      onLicenseSuccess,
    },
    ref
  ) => {
    const [isEnabled, setEnabled] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [youtubeId, setYoutubeId] = useState("");
    const [placingOrder, setPlacingOrder] = useState(false);
    const auth = useAuth();
    const wrappedEthTestNetAddress =
      "0xA6FA4fB5f76172d178d61B04b0ecd319C5d1C0aa";
    const wrappedEthMainnetAddress =
      "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619";
    const [subscriberCount, setSubscriberCount] = useState(null);
    const [smallLicensePrice, setSmallLicensePrice] = useState(null);
    const [mediumLicensePrice, setMediumLicensePrice] = useState(null);
    const [largeLicensePrice, setLargeLicensePrice] = useState(null);
    const [price, setPrice] = useState();
    const [progressText, setProgressText] = useState("");
    const [errorText, setErrorText] = useState('');


    const onPlaceOrder = async () => {
      if (window.ethereum) {
        setPlacingOrder(true);

        const selectedProvider = getSelectedProvider();
        const provider = new ethers.providers.Web3Provider(selectedProvider);

        //Approve the ERC20 transactions
        const useMainnet: Boolean =
          process.env.REACT_APP_USE_POLYGON_MAINNET === "true";
        const wrappedEthAddress = useMainnet
          ? wrappedEthMainnetAddress
          : wrappedEthTestNetAddress;
        const wrappedEthContract = new ethers.Contract(
          wrappedEthAddress,
          ERC20Artifact.abi,
          provider.getSigner()
        );

        const licenseContract = new ethers.Contract(
          song.license_address,
          LicenseSoulboundNFTArtifact.abi,
          provider.getSigner()
        );
        const licensePurchasePrice = ethers.utils.parseEther(price);
        setProgressText("Please complete your order through wallet extension.");
        // Approve the license contract to transfer the license price to the owner
        try {
          await wrappedEthContract.approve(
            song.license_address,
            licensePurchasePrice
          );
        } catch (error) {
          if (error.toString().includes('user rejected transaction')) {
            setErrorText("Rejected transaction, please try again");
          } else {
            setErrorText("Something went wrong, please try again");
          }
          setPlacingOrder(false);
          return;
        }
        const licenseId = crypto.randomUUID();
        let size = -1;
        if (price === smallLicensePrice) {
          size = 0;
        } else if (price === mediumLicensePrice) {
          size = 1;
        } else if (price === largeLicensePrice) {
          size = 2;
        }

        try {
          const transaction = await licenseContract.functions[
            "purchaseLicense(string,address,uint256)"
          ](licenseId, wrappedEthAddress, size, { gasLimit: 10000000 });
          setProgressText("Licensing...");


          // wait for the transfer event
          console.log("going to listen for the transfer event");

          licenseContract.on("Transfer", async (from, to, tokenId) => {
            console.log('token id is ', tokenId)
            console.log('licenseId is ', licenseId)

            const licenseExpiration = (
              await licenseContract.getExpirationDate(licenseId)
            ).toString();
  
  
          const json = {
            license_id: licenseId,
            license_address: song.license_address,
            owner: auth.user.wallet_address,
            song_id: song.id,
            expiration: licenseExpiration,
          };
          axios
            .post(
              process.env.REACT_APP_BACKEND_URL + "/add_new_license",
              JSON.stringify(json),
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              onLicenseSuccess();
            });

          });

        } catch (error) {
          setErrorText("Something went wrong, please try again");
          setPlacingOrder(false);
          return;
        }


   
      }
    };


    useEffect(() => {
      getLicensePrice();
    }, []);

    const getLicensePrice = async () => {
      const selectedProvider = getSelectedProvider();
      const provider = new ethers.providers.Web3Provider(selectedProvider);
      const licenseContract = new ethers.Contract(
        song.license_address,
        LicenseSoulboundNFTArtifact.abi,
        provider.getSigner()
      );
      const smallLicensePrice = await licenseContract.getSmallLicensePrice();
      const mediumLicensePrice = await licenseContract.getLargeLicensePrice();
      const largeLicensePrice = await licenseContract.getMediumLicensePrice();
      setSmallLicensePrice(
        ethers.utils.formatEther(smallLicensePrice).toString()
      );
      setLargeLicensePrice(
        ethers.utils.formatEther(largeLicensePrice).toString()
      );
      setMediumLicensePrice(
        ethers.utils.formatEther(mediumLicensePrice).toString()
      );
    };

    useEffect(() => {
      setPrice(smallLicensePrice);
      setEnabled(true);
    },);


    return (
      <Modal
        backgroundOpacity={"rgb(0,43,66,0.9)"}
        ref={ref}
        show={showSongLicenseModal}
      >
        <SongLicenseModalContainer>
          <CloseCircle bg={close_circle} onClick={onLicenseCloseClick} />

          <Column
            style={{
              gap: "1rem",
              paddingTop: "15%",
              position: "relative",
              textAlign: "left",
            }}
          >
            <Row style={{ justifyContent: "start", marginTop: "-15%" }}>
              <Text bold={true} size={"1.4rem"}>
                Check Out
              </Text>
            </Row>
            <Row>
              <SongLicenseContainer>
                <SongLicenseImg src={song.song_cover_s3_link} />
                <Column
                  style={{ justifyContent: "center", paddingLeft: "10%" }}
                >
                  <Text bold={true}>{song.song_name}</Text>
                  <Text>{song.artist_stage_name}</Text>
                </Column>
              </SongLicenseContainer>
            </Row>
            <Row
              style={{
                justifyContent: "flex-start",
                marginTop: "5%",
                height: "100%",
                width: "100%",
              }}
            >
              {/* <Text style={{ maxWidth: "50%", textAlign: "left" }}>
                Based on your subscriber count, your license price is{" "}
              </Text> */}
              <Text style={{ maxWidth: "50%", textAlign: "left" }}>
                Your license price is{" "}
              </Text>
              <CheckoutPriceContainer>
                <img src={eth_icon} />
                {price} ETH
              </CheckoutPriceContainer>
            </Row>
            <Row style={{ width: "100%", justifyContent: "flex-end" }}>
              {!placingOrder ? (
                <Column style={{ width: "100%" }}>
                <SimpleButton
                  disabled={!isEnabled}
                  id="placeOrder"
                  style={{ alignSelf: "end" }}
                  onClick={onPlaceOrder}
                >
                  Place Order
                </SimpleButton>
                <BlockChainErrorText>{errorText}</BlockChainErrorText>
                </Column>
              ) : (
                <Column style={{ width: "100%" }}>
                  <SimpleButton
                    style={{ paddingInline: "7%", marginLeft: "auto" }}
                  >
                    <CircularSVG>
                      <CustomCircle
                        cx="15"
                        cy="15"
                        r="10"
                        fill="none"
                        stroke-width="5"
                        stroke-miterlimit="10"
                      />
                    </CircularSVG>
                  </SimpleButton>
                  <ProgressText>{progressText}</ProgressText>
                </Column>
              )}
            </Row>
          </Column>
        </SongLicenseModalContainer>
      </Modal>
    );
  }
);

export default SongLicenseModal;
